import { render, staticRenderFns } from "./ParticlesJS.vue?vue&type=template&id=3e4ad677&scoped=true&"
import script from "./ParticlesJS.vue?vue&type=script&lang=js&"
export * from "./ParticlesJS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4ad677",
  null
  
)

export default component.exports